import { render, staticRenderFns } from "./configPay.vue?vue&type=template&id=d3561e96&scoped=true&"
import script from "./configPay.vue?vue&type=script&lang=js&"
export * from "./configPay.vue?vue&type=script&lang=js&"
import style0 from "./configPay.vue?vue&type=style&index=0&id=d3561e96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3561e96",
  null
  
)

export default component.exports